// src/scripts/fluco-lib/events.js
var EVENTS = {
  SHOPIFY_BLOCK_SELECT: "shopify:block:select",
  SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
  SHOPIFY_SECTION_SELECT: "shopify:section:select",
  SHOPIFY_SECTION_LOAD: "shopify:section:load",
  SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
  SWIPER_JS_LOADED: "fluco_section:swiper_js_loaded",
  COUNTDOWN_TIMER_COMPLETED_EVENT: "fluco_section:countdown_timer_completed"
};
var events_default = EVENTS;

// src/scripts/sections/hero-gallery-1.js
var { SHOPIFY_BLOCK_SELECT, SHOPIFY_BLOCK_DESELECT } = events_default;
var HeroGallery1 = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      slides: "[js-slide]",
      thumbnails: "[js-thumbnail]",
      slideByBlockId: (blockId) => `[js-slide][data-block-id="${blockId}"]`,
      thumbByBlockId: (blockId) => `[js-thumbnail][data-block-id="${blockId}"]`,
      activeSlide: "[js-slide][data-active]",
      activeThumb: "[js-thumbnail][data-active]",
      lazyImages: "img[loading='lazy']",
      VideoPair: ".fluco-video-pair"
    };
    this.attrs = {
      active: "data-active",
      visible: "data-visible"
    };
  }
  connectedCallback() {
    this.thumbnails = this.querySelectorAll(this.selectors.thumbnails);
    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", (event) => {
        this.gotoSlideByBlockId(event.currentTarget.dataset.blockId);
      });
      thumbnail.addEventListener("mouseover", (event) => {
        this.preloadSlideByBlockId(event.currentTarget.dataset.blockId);
      });
      thumbnail.addEventListener("focus", (event) => {
        this.preloadSlideByBlockId(event.currentTarget.dataset.blockId);
      });
    });
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_SELECT,
      (event) => {
        this.gotoSlideByBlockId(event.detail.blockId);
      },
      this.eventOptions
    );
    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_DESELECT,
      () => this.gotoFirstSlide(),
      this.eventOptions
    );
  }
  disconnectedCallback() {
    this.eventController.abort();
  }
  /**
   * Preload media within a slide so that the media is loaded premptively.
   * @param {String} blockId - The block ID for the slide.
   */
  preloadSlideByBlockId(blockId) {
    const slide = this.querySelector(this.selectors.slideByBlockId(blockId));
    if (!slide) {
      return;
    }
    const lazyImages = slide.querySelectorAll(this.selectors.lazyImages);
    lazyImages.forEach((image) => {
      image.loading = "eager";
    });
  }
  gotoFirstSlide() {
    const firstSlide = this.querySelector(this.selectors.slides);
    this.gotoSlideByBlockId(firstSlide.dataset.blockId);
  }
  /**
   * Go to slide based on block ID
   * @param {String} blockId - The block ID for the slide to activate.
   */
  gotoSlideByBlockId(blockId) {
    const newSlide = this.querySelector(this.selectors.slideByBlockId(blockId));
    const newThumb = this.querySelector(this.selectors.thumbByBlockId(blockId));
    if (!newSlide) {
      return;
    }
    const currentSlide = this.querySelector(this.selectors.activeSlide);
    const currentThumb = this.querySelector(this.selectors.activeThumb);
    if (currentSlide) {
      currentSlide.removeAttribute(this.attrs.active);
      currentSlide.inert = true;
      const currentSlideVideoPair = currentSlide.querySelector(
        this.selectors.VideoPair
      );
      currentSlideVideoPair?.setAttribute(this.attrs.visible, false);
    }
    if (newSlide) {
      newSlide.setAttribute(this.attrs.active, true);
      newSlide.inert = false;
      const newSlideVideoPair = newSlide.querySelector(this.selectors.VideoPair);
      newSlideVideoPair?.setAttribute(this.attrs.visible, true);
    }
    currentThumb?.removeAttribute(this.attrs.active);
    newThumb?.setAttribute(this.attrs.active, true);
  }
};
if (!customElements.get("fluco-local-v5-hero-gallery-1")) {
  customElements.define("fluco-local-v5-hero-gallery-1", HeroGallery1);
}
